import { jsPDF } from "jspdf";
(function (jsPDFAPI) {
    jsPDFAPI.events.push(['addFonts', function () {
        try {
            window.__addPDFFonts(this);
        } catch { console.log('error loading fonts') }
    }]);
})(jsPDF.API);